import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.companyApi;
const webPath = apiConfig.financeApi;
const managePath = apiConfig.commonApi

//所属园区列表
export const innovationBaseInfo = {
    list: webPath + "/innovationBaseInfo/list", // 提交(get)
    childrenList: webPath + "/innovationBaseInfo/childrenList", // 提交(get)
};
// 短信验证码
export const phoneCommon = {
    forgetPwd: webPath + "/common/smsCheck/forgetPwd", // 其他用户忘记密码手机号短信发送(post)  不传信用代码
    retrievePwd: webPath + "/common/smsCheck/retrievePwd", // 忘记密码手机号短信发送(post)
    retrievePwdCheck: webPath + "/common/smsCheck/retrievePwdCheck", // 忘记密码手机号短信验证码校验(post)
    registerSMS: webPath + "/common/smsCheck/registerSMS", // 注册手机号短信发送(post)
    registerSMSCheck: webPath + "/common/smsCheck/registerSMSCheck", // 注册手机号短信验证码校验(post)
    sealSMS: webPath + "/common/smsCheck/sealSMS", // 注册手机号短信发送(post)
    sealSMSCheck: webPath + "/common/smsCheck/sealSMSCheck", // 注册手机号短信验证码校验(post)
    }

//邮箱验证码
export const common = {
    submitOtherPwd: webPath + "/common/mail/submitOtherPwd", // 提交(post)
    submitMailCode: webPath + "/common/mail/submitMailCode", // 提交(post)
    sendCode: webPath + "/common/mail/sendCode", // 发送(post)
    schedule: webPath + "/common/mail/schedule", // 查询账号(post)
    submitCode: webPath + "/common/mail/submitCode", // 注册提交验证码(post)
    sendMailCode: webPath + "/common/mail/sendMailCode", // 注册获取验证码(post)
};


//企业金融信息
export const financeCompanyInfo = {
    add: rootPath + "/financeCompanyInfo/add", // 新增(post)
    edit: rootPath + "/financeCompanyInfo/edit", // 修改(put)
    pageList: rootPath + "/financeCompanyInfo/pageList", // 分页数据(get)
    detail: rootPath + "/financeCompanyInfo/detail", // 详情(get)
    list: rootPath + "/financeCompanyInfo/list", // 无分页数据(get)
    remove: rootPath + "/financeCompanyInfo/remove/", // 根据id删除-批量删除(delete)
};

//融资需求
export const financeDemand = {
    edit: rootPath + "/financeDemand/edit", // 修改(put)
    add: rootPath + "/financeDemand/add", // 新增(post)
    pageList: rootPath + "/financeDemand/pageList", // 分页数据(get)
    detail: rootPath + "/financeDemand/detail", // 详情(get)
    list: rootPath + "/financeDemand/list", // 无分页数据(get)
    remove: rootPath + "/financeDemand/remove/", // 根据id删除-批量删除(delete)
};

//需求回复
export const financeDemandReply = {
    edit: rootPath + "/financeDemandReply/edit", // 修改(put)
    add: rootPath + "/financeDemandReply/add", // 新增(post)
    pageList: rootPath + "/financeDemandReply/pageList", // 分页数据(get)
    detail: rootPath + "/financeDemandReply/detail", // 详情(get)
    list: rootPath + "/financeDemandReply/list", // 无分页数据(get)
    remove: rootPath + "/financeDemandReply/remove/", // 根据id删除-批量删除(delete)
};

//投资对接
export const financeDocking = {
    edit: rootPath + "/financeDocking/edit", // 修改(put)
    add: rootPath + "/financeDocking/add", // 新增(post)
    pageList: rootPath + "/financeDocking/pageList", // 分页数据(get)
    pageCompanyList: rootPath + "/financeDocking/pageCompanyList", // 分页数据(get)
    detail: rootPath + "/financeDocking/detail", // 详情(get)
    list: rootPath + "/financeDocking/list", // 无分页数据(get)
    remove: rootPath + "/financeDocking/remove/", // 根据id删除-批量删除(delete)
};
//企业贷款
export const financeLoan = {
    edit: rootPath + "/financeLoan/edit", // 修改(post)
    add: rootPath + "/financeLoan/add", // 新增(post)
    pageList: rootPath + "/financeLoan/pageList", // 分页数据(get)
    detail: rootPath + "/financeLoan/detail", // 详情(get)
    list: rootPath + "/financeLoan/list", // 无分页数据(get)
    remove: rootPath + "/financeLoan/remove/", // 根据id删除-批量删除(delete)
};

//项目管理
export const financeProject = {
    edit: rootPath + "/financeProject/edit", // 编辑(post)
    add: rootPath + "/financeProject/add", // 新增(post)
    pageList: rootPath + "/financeProject/pageList", // 分页数据(get)
    detail: rootPath + "/financeProject/detail", // 详情(get)
    list: rootPath + "/financeProject/list", // 无分页数据(get)
    remove: rootPath + "/financeProject/remove/", // 根据id删除-批量删除(delete)
};

//金融顾问-咨询
export const financeConsultation = {
    edit: rootPath + "/financeConsultation/edit", // 编辑(post)
    add: rootPath + "/financeConsultation/add", // 新增(post)
    pageList: rootPath + "/financeConsultation/pageList", // 分页数据(get)
    detail: rootPath + "/financeConsultation/detail", // 详情(get)
    list: rootPath + "/financeConsultation/list", // 无分页数据(get)
    remove: rootPath + "/financeConsultation/remove/", // 根据id删除-批量删除(delete)
};

//金融顾问-咨询回复
export const financeConsultationReply = {
    edit: rootPath + "/financeConsultationReply/edit", // 编辑(post)
    add: rootPath + "/financeConsultationReply/add", // 新增(post)
    pageList: rootPath + "/financeConsultationReply/pageList", // 分页数据(get)
    detail: rootPath + "/financeConsultationReply/detail", // 详情(get)
    list: rootPath + "/financeConsultationReply/list", // 无分页数据(get)
    remove: rootPath + "/financeConsultationReply/remove/", // 根据id删除-批量删除(delete)
};


//投资经理人管理
export const financeInvestorManager = {
    edit: rootPath + "/financeInvestorManager/edit", // 修改(post)
    add: rootPath + "/financeInvestorManager/add", // 新增(post)
    pageList: rootPath + "/financeInvestorManager/pageList", // 分页数据(get)
    detail: rootPath + "/financeInvestorManager/detail", // 详情(get)
    list: rootPath + "/financeInvestorManager/list", // 无分页数据(get)
    investorManagerInfo: rootPath + "/financeInvestorManager/investorManagerInfo", // 基本信息(get)
    remove: rootPath + "/financeInvestorManager/remove/", // 根据id删除-批量删除(delete)
};

//金融机构基本信息
export const financeInstitution = {
    edit: rootPath + "/financeInstitution/edit", // 修改(post)
    add: rootPath + "/financeInstitution/add", // 新增(post)
    pageList: rootPath + "/financeInstitution/pageList", // 分页数据(get)
    detail: rootPath + "/financeInstitution/detail", // 详情(get)
    list: rootPath + "/financeInstitution/list", // 无分页数据(get)
    remove: rootPath + "/financeInstitution/remove/", // 根据id删除-批量删除(delete)
};

//金融机构-产品管理
export const financeProduct = {
    edit: rootPath + "/financeProduct/edit", // 修改(post)
    add: rootPath + "/financeProduct/add", // 新增(post)
    pageList: rootPath + "/financeProduct/pageList", // 分页数据(get)
    detail: rootPath + "/financeProduct/detail", // 详情(get)
    list: rootPath + "/financeProduct/list", // 无分页数据(get)
    remove: rootPath + "/financeProduct/remove/", // 根据id删除-批量删除(delete)
};

//金融机构-金融顾问管理
export const financeAdvisor = {
    edit: rootPath + "/financeAdvisor/edit", // 修改(post)
    add: rootPath + "/financeAdvisor/add", // 新增(post)
    pageList: rootPath + "/financeAdvisor/pageList", // 分页数据(get)
    detail: rootPath + "/financeAdvisor/detail", // 详情(get)
    list: rootPath + "/financeAdvisor/list", // 无分页数据(get)
    advisorInfo: rootPath + "/financeAdvisor/advisorInfo", // 基本信息(get)
    remove: rootPath + "/financeAdvisor/remove/", // 根据id删除-批量删除(delete)
};

//投资人基本信息
export const financeInvestor = {
    add: rootPath + "/financeInvestor/add", // 新增(post)
    edit: rootPath + "/financeInvestor/edit", // 修改(put)
    list: rootPath + "/financeInvestor/list", // 无分页数据(get)
    detail: rootPath + "/financeInvestor/detail", // 详情(get)
};

//投资机构基本信息
export const financeMechanism = {
    add: rootPath + "/financeMechanism/add", // 新增(post)
    edit: rootPath + "/financeMechanism/edit", // 修改(put)
    list: rootPath + "/financeMechanism/list", // 无分页数据(get)
    detail: rootPath + "/financeMechanism/detail", // 详情(get)
};


// 门户端

// 投资人
export const financeInvestorWeb = {
    add: rootPath + "/financeInvestor/add", // 新增(post)
    pageList: webPath + "/financeInvestor/pageList", // 分页数据(get)
    list: webPath + "/financeInvestor/list", // 分页数据(get)
    detail: webPath + "/financeInvestor/detail", // 详情(get)
};

// 投资机构
export const financeMechanismWeb = {
    add: rootPath + "/financeMechanism/add", // 新增(post)
    pageList: webPath + "/financeMechanism/pageList", // 分页数据(get)
    list: webPath + "/financeMechanism/list", // 分页数据(get)
    detail: webPath + "/financeMechanism/detail", // 详情(get)
};

//金融机构
export const financeInstitutionWeb = {
    edit: webPath + "/financeInstitution/edit", // 修改(post)
    add: webPath + "/financeInstitution/add", // 新增(post)
    pageList: webPath + "/financeInstitution/pageList", // 分页数据(get)
    detail: webPath + "/financeInstitution/detail", // 详情(get)
    list: webPath + "/financeInstitution/list", // 无分页数据(get)
    remove: webPath + "/financeInstitution/remove/", // 根据id删除-批量删除(delete)
};

// 金融产品
export const financeProductWeb = {
    add: rootPath + "/financeProduct/add", // 新增(post)
    pageList: webPath + "/financeProduct/pageList", // 分页数据(get)
    list: webPath + "/financeProduct/list", // 分页数据(get)
    detail: webPath + "/financeProduct/detail", // 详情(get)
};

//创业项目
export const financeProjectWeb = {
    add: rootPath + "/financeProject/add", // 新增(post)
    pageList: webPath + "/financeProject/pageList", // 分页数据(get)
    detail: webPath + "/financeProject/detail", // 详情(get)
};

//金融顾问
export const financeAdvisorWeb = {
    add: rootPath + "/financeAdvisor/add", // 新增(post)
    pageList: webPath + "/financeAdvisor/pageList", // 分页数据(get)
    detail: webPath + "/financeAdvisor/detail", // 详情(get)
};

//需求列表
export const basicsNeedInfo = {
    drawNeed: managePath + "/basicsNeedInfo/drawNeed", // 新增(post)
    pageList: webPath + "/basicsNeedInfo/pageList", // 分页数据(get)
    detail: webPath + "/basicsNeedInfo/detail", // 详情(get)
};


//课程表
export const basicsCourseInfoWeb = {
    pageList: webPath + "/basicsCourseInfo/pageList", // 分页数据(get)
    detail: webPath + "/basicsCourseInfo/detail", // 详情(get)
};


//文章
export const basicsEssayInfoweb = {
    pageList: webPath + "/basicsEssayInfo/pageList", // 分页
    getDetail: webPath + "/basicsEssayInfo/detail", // 详情

};
